<template>
  <div id="goTop">
    <transition name="slide-fade">
      <div class="goTop" v-show="goTopShow" @click="goTop">
        <i class="iconfont icon-shang2 goTopIcon"></i>
        <!-- 回到顶部 -->
      </div>
    </transition>
  </div>
</template>

 <script>
export default {
  name: "goTop",
  data() {
    return {
      scrollTop: "",
      goTopShow: false
    };
  },
  watch: {
    scrollTop(val) {
      if (this.scrollTop > 500) {
        this.goTopShow = true;
      } else {
        this.goTopShow = false;
      }
    }
  },
  methods: {
    handleScroll() {
      this.scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (this.scrollTop > 500) {
        this.goTopShow = true;
      }
    },
    goTop() {
      let timer = null,
        _that = this;
      cancelAnimationFrame(timer);
      timer = requestAnimationFrame(function fn() {
        if (_that.scrollTop > 0) {
          _that.scrollTop -= 250;
          document.body.scrollTop = document.documentElement.scrollTop =
            _that.scrollTop;
          timer = requestAnimationFrame(fn);
        } else {
          cancelAnimationFrame(timer);
          _that.goTopShow = false;
        }
      });
    }
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  }
};
</script>

<style scoped lang="scss">
@media screen and (min-width: 1026px) {
  .slide-fade-enter-active {
    transition: all 0.6s ease;
  }
  .slide-fade-leave-active {
    transition: all 0.6s cubic-bezier(1, 0.5, 0.8, 1);
  }
  .slide-fade-enter, .slide-fade-leave-to {
    transform: translateY(60px);
  }
  .goTop {
    position: fixed;
    right: 40px;
    bottom: 60px;
    width: 60px;
    height: 60px;
    border-radius: 50%;
    background: #fff;
    padding: 10px;
    cursor: pointer;
    /* box-shadow: 0 0 6px rgba(0, 0, 0, 0.12); */
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    border: 1px solid rgba(51, 153, 255, 1);
  }
  .goTop:hover {
    background: rgba(51, 153, 255, 1);
  }
  .goTop:hover .goTopIcon {
    color: #fff;
  }
  .goTopIcon {
    font-size: 18px;
    color: rgba(51, 153, 255, 0.8);
  }
}
@media screen and (min-width: 768px) and (max-width: 1025px) {
  .slide-fade-enter-active {
    transition: all 0.6s ease;
  }
  .slide-fade-leave-active {
    transition: all 0.6s cubic-bezier(1, 0.5, 0.8, 1);
  }
  .slide-fade-enter, .slide-fade-leave-to {
    transform: translateY(60px);
  }
  .goTop {
    position: fixed;
    right: 40px;
    bottom: 60px;
    width: 60px;
    height: 60px;
    border-radius: 50%;
    background: #fff;
    padding: 10px;
    cursor: pointer;
    /* box-shadow: 0 0 6px rgba(0, 0, 0, 0.12); */
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    border: 1px solid rgba(51, 153, 255, 1);
  }
  .goTop:hover {
    background: rgba(51, 153, 255, 1);
  }
  .goTop:hover .goTopIcon {
    color: #fff;
  }
  .goTopIcon {
    font-size: 18px;
    color: rgba(51, 153, 255, 0.8);
  }
}
@media screen and (max-width: 767px) {
  .slide-fade-enter-active {
    transition: all 0.6s ease;
  }
  .slide-fade-leave-active {
    transition: all 0.6s cubic-bezier(1, 0.5, 0.8, 1);
  }
  .slide-fade-enter, .slide-fade-leave-to {
    transform: translateY(60px);
  }
  .goTop {
    z-index: 9999;
    position: fixed;
    right: 10px;
    bottom: 40px;
    width: 50px;
    height: 50px;
    border-radius: 50%;
    background: #fff;
    padding: 10px;
    cursor: pointer;
    /* box-shadow: 0 0 6px rgba(0, 0, 0, 0.12); */
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    border: 1px solid rgba(51, 153, 255, 1);
  }
 

  .goTopIcon {
    font-size: 18px;
    color: rgba(51, 153, 255, 0.8);
  }
}
</style>